angular.module('spaceChat.clientArchive', [
  'ihestia-widgets-templates-app',
  'ihestiaSsoBase',
  'spaceChat.common'
]);
